// Central site constants for SEO metadata + shared JSON-LD schema.
// Update SITE_URL when the production domain is finalized (single source of truth).

export const SITE_URL = "https://lotwisehome.ca";
export const SITE_NAME = "LotWise Home";
export const SITE_TAGLINE = "Handled as a system. Presented properly.";
export const CONTACT_EMAIL = "hello@lotwiseauto.ca";

// City list used for LocalBusiness schema
export const SERVICE_AREAS = [
  "Ottawa", "Pembroke", "Petawawa", "Perth", "Arnprior",
  "Renfrew", "Carleton Place", "Rockland", "Cornwall", "Kingston",
];

export const DEFAULT_DESCRIPTION =
  "LotWise Home is one managed process for getting a property market-ready and keeping its presentation handled. Photography, video, aerial, listing preparation, marketing assets, and vendor coordination — coordinated end-to-end for real estate agents, teams, brokerages, builders, developers, and property owners across southeastern Ontario.";

export const OG_IMAGE = `${SITE_URL}/generated/hero.png`;

// Shared JSON-LD building blocks
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": SITE_NAME,
  "url": SITE_URL,
  "logo": `${SITE_URL}/favicon-512.png`,
  "email": CONTACT_EMAIL,
  "areaServed": {
    "@type": "AdministrativeArea",
    "name": "Southeastern Ontario, Canada",
  },
  "sameAs": [],
};

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${SITE_URL}#business`,
  "name": SITE_NAME,
  "url": SITE_URL,
  "image": `${SITE_URL}/favicon-512.png`,
  "email": CONTACT_EMAIL,
  "priceRange": "$$",
  "areaServed": SERVICE_AREAS.map((c) => ({ "@type": "City", "name": c })),
  "address": {
    "@type": "PostalAddress",
    "addressRegion": "ON",
    "addressCountry": "CA",
  },
};

export const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Real estate listing support",
  "provider": { "@type": "Organization", "name": SITE_NAME, "url": SITE_URL },
  "areaServed": "Southeastern Ontario, Canada",
  "description":
    "Property photography, listing detail capture, room and feature documentation, MLS-ready and web-ready asset preparation, and owned-channel listing presentation support for real estate agents, teams, and brokerages.",
  "offers": [
    { "@type": "Offer", "name": "Listing Essential", "price": "395", "priceCurrency": "CAD" },
    { "@type": "Offer", "name": "Listing Standard", "price": "595", "priceCurrency": "CAD" },
    { "@type": "Offer", "name": "Listing Plus",     "price": "895", "priceCurrency": "CAD" },
    { "@type": "Offer", "name": "Active Agent Plan","price": "1295","priceCurrency": "CAD" },
    { "@type": "Offer", "name": "Team Standard",    "price": "2795","priceCurrency": "CAD" },
  ],
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "url": SITE_URL,
  "name": SITE_NAME,
};

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((it, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": it.name,
      "item": `${SITE_URL}${it.path}`,
    })),
  };
}
